import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Settings = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path d="M3 9L3 15" stroke="currentColor" stroke-width="1.5" />
    <path d="M3 1V7" stroke="currentColor" stroke-width="1.5" />
    <path d="M8 7L8 15" stroke="currentColor" stroke-width="1.5" />
    <path d="M8 1V5" stroke="currentColor" stroke-width="1.5" />
    <path d="M13 12L13 15" stroke="currentColor" stroke-width="1.5" />
    <path d="M13 1V10" stroke="currentColor" stroke-width="1.5" />
    <path d="M15.6201 12H10.3701" stroke="currentColor" stroke-width="1.5" />
    <path d="M10.6299 5H5.37988" stroke="currentColor" stroke-width="1.5" />
    <path d="M5.62988 9H0.379883" stroke="currentColor" stroke-width="1.5" />
  </svg>
));
